import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { addApp, updateApp } from '../../../../../../../actions/sceneActions'
import { Card, Button, Row, Col, Form } from "react-bootstrap";
import { DISPLAY_APPS_SUCCESS_SAVE, SUCCESS_TEXT } from "../../messageText";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import { stripTrailingSlash, validURL } from "../../../../../../../utils";
import { CloudUrlStudio } from "../../../../../../../actions/api";
class Polls extends Component {
  state = {
    URL: null,
    stateChanged: false,
    updateApi: false,  
    buttonDis:false,
    loader:false,
    errorLink : false
  };
 
  componentDidMount() {
    const { scenes, location } = this.props;
    const { app_data } = scenes.updateSceneData;
    if (app_data) {
      const { URL } = app_data;
      if (URL && location.pathname.includes('update')) this.setState({ URL, updateApi: true });
    }
  }

  onSaveQRCode = (event) => {
    const { param } = this.props;
    const { URL } = this.state;
    if (!URL || URL === '') {
      Swal.fire({
        title: 'Error',
        text: 'Please enter correct url!',
        type: "error",
        icon: 'error',
        showConfirmButton: false,
        timer: 3000
      });
      return;
    }

    this.setState({buttonDis:true, loader:true})
    this.state.updateApi
      ? this.props.updateApp(
        param.contentMixId,
        this.props.scenes.updateSceneData.id,
        { URL},
        11,
        this.onSaveCallBack
      )
      : this.props.addApp(
        param.contentMixId,
        param.positionID,
        { URL },
        "Live Poll",
        11,
        this.onSaveCallBack
      );
  };
  onBack = (event) => {
    const { params } = this.props.match;
    const { pathname } = this.props.location; 
    if (!this.state.stateChanged) {
      this.props.history(stripTrailingSlash(pathname,params))
      return;
    }
 
    Swal.fire({
      title: "Are you sure?",
      text:
        "Your changes have not been saved. Do you want to save before you leave the page?",
      // icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Discard Changes",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.onSaveQRCode()
      } else if (result.dismiss === "cancel") {
        this.props.history(stripTrailingSlash(pathname,params))
      }
    });
  };
  onSaveCallBack = () => {
    const { params } = this.props.match;
    Swal.fire({
      title: SUCCESS_TEXT,
      text: DISPLAY_APPS_SUCCESS_SAVE,
      type: "success",
      icon: "success",
      showConfirmButton: false,
      timer: 3000,
    }).then((result) => {
      this.setState({buttonDis:false, loader:false})
      this.props.history(`/studio/${params.wallId}`);
    });
  };

  
  onTextUrl = (event) => { 
    var enterUrl = event.target.value; 
      if (enterUrl.includes("https://")) { 
        this.setState({ URL: enterUrl, errorLink: false });
      } else {
        this.setState({ URL: null, errorLink: true });
      }
    
  };

  render() {
    const { match } = this.props;
    const { buttonDis,URL, loader, errorLink, updateApi } = this.state;
    const { pathname } = this.props.location; 

    return (
      <>
     { !updateApi ?
        <NavigationHeader
          name={'Live Polls'} 
          backToNavigation={`${pathname ? stripTrailingSlash(pathname,match) : ''}`}
          /> : null }
        <div className="container-fluid subheader_content">
          <Card className="select_wall mb-3 rounded-0 border-0">
            <Card.Body className="p-0">
              <Row>
                <Col lg={4} className="border-right-lg">
                  <Card className="border-0 rounded-0">
                    <Card.Body className="p-4 card_height">
                      <Form.Group className="form-group" controlId="formBasicEmail">
                        <Form.Label>Url</Form.Label>
                        <Form.Control
                          type="text"
                          className={`text-url-update ${errorLink ? 'error-input' : ""}`}
                          autocomplete="off"
                          defaultValue={URL}
                          onChange={this.onTextUrl}
                        />
                      { errorLink ? <span className="text-danger">Please fill valid URL ex : https://url</span> : null }
                      </Form.Group>
                      

                      <div className="poll-flow">
                          <p>Steps to Follow</p>
                          <ul className="poll-flow-links">
                            <li>Go to <a href="https://www.slido.com/" target="_blank">slido.com</a></li>
                            <li>Login or Create an Account</li>
                            <li>Create a Live poll</li>
                            <li>Once you are done with the setup, Click on Present</li>
                            <li>Copy the present URL and paste it here in Enter Live Poll Url Field</li>
                            <li>Click on Save.</li>
                          </ul>
                          <p>Make sure to give enough time for the live poll slide so users can check their entries in real-time.</p>
                      </div>
                      <div className="live-polls-apps mt-5 pt-5">
                        <h6>Our Preferred Live Poll Partners:</h6>
                        <ul className="mb-0">
                          <li><img src={`${CloudUrlStudio}/app_icons/slido.png?v=1`} className="img-fluid" alt={"slido"} /></li>
                          <li><img src={`${CloudUrlStudio}/app_icons/strawpoll.png?v=1`} className="img-fluid" alt={"slido"} /></li>
                          <li><img src={`${CloudUrlStudio}/app_icons/vevox.png?v=1`} className="img-fluid" alt={"slido"} /></li>
                        </ul>
                        <ul className="mb-0">
                          <li><img src={`${CloudUrlStudio}/app_icons/poll_everywhere.png?v=1`} className="img-fluid" alt={"slido"} /></li>
                          <li><img src={`${CloudUrlStudio}/app_icons/mentimeter.png?v=1`} className="img-fluid" alt={"slido"} /></li>
                          <li><img src={`${CloudUrlStudio}/app_icons/slideswithfriends.png?v=1`} className="img-fluid" alt={"slido"} /></li>
                        </ul>
                      </div>

                    </Card.Body>
                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-3">
                      <button
                        className="btn btn-outline-dark me-3 btn-min-w"
                        onClick={this.onBack}
                      >
                        <span className="position-relative">Back</span>
                      </button>
                      <Button
                        variant="primary"
                        disabled={ buttonDis } className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`}
                        onClick={this.onSaveQRCode}
                        id="Studio_QRCode_App_Users"
                      >
                        Save
                      </Button>
                    </Card.Footer>
                  </Card>
                </Col>
                <Col
                  lg={8}
                  className="d-flex align-items-center justify-content-center"
                >
                    <Card className="border-0 card w-100">
                    <Card.Body className="border-0">
                      <div className="wall_view">

                
                         <div className="wall_view_wrapper">
                          { !errorLink && validURL(URL) ? (
                            <iframe
                            className="preview-display-wall"
                              src={URL}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                display: "block",
                              }}
                            ></iframe>
                          ) : (
                             <img src={`${CloudUrlStudio}/app_icons/dummy-live-poll.png`}/>
                          )}
                         
                        </div>
                      </div>
                    </Card.Body>
                  </Card>

                </Col>
              </Row>
            </Card.Body>
          </Card>

        </div>
      </>

    );
  }
}
const mapStateToProps = (state) => { 
  return {
    studioWall: state.studio.studioWall,
    scenes: state.scene,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
      dispatch(
        addApp(contentMixId, position, appContent, appName, appId, callBack)
      ),
    updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) => dispatch(updateApp(contentMixId, sceneContentId, appContent, appId, callBack)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Polls);
